import { render } from "./App.vue?vue&type=template&id=5e45a762&scoped=true&bindings={\"maxScore\":\"setup\",\"startGame\":\"setup\",\"endGame\":\"setup\",\"playAgain\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5e45a762&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e45a762"

export default script